import { render, staticRenderFns } from "./ConfirmacaoAlterarExtra.vue?vue&type=template&id=2f3edf68&"
import script from "./ConfirmacaoAlterarExtra.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoAlterarExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports